module.exports = __webpack_public_path__ + "img/intro.e1c4dee5.png";